import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button } from "../../../controls";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import AddEditGroup from "./AddEditGroup";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";
import { formatDate } from "hooks";

const Groups = () => {
  const { access } = useContext(AppContext);
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const { setLoader } = useContext(AppContext);
  const [groups, setGroups] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    API(controller.CstmrGroup + action.GetAllByOrg).get((res) => {
      res.status === 200 && setGroups([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this group?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setGroups((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.CstmrGroup).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (val) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      {access?.customerGroup?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val)}
            size="small"
            color="primary"
          >
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
      {access?.customerGroup?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
            className="mr-5 p-5"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const HeaderComp = () =>
    access?.customerGroup?.create && (
      <Button onClick={() => handleAddEdit()}>Add Group</Button>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "name", label: "Name" },
          { id: "cstmr", label: "Number of Customer" },
          { id: "desc", label: "Description" },
          { id: "createDate", label: "Create Date" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={[
          ...groups.map((j) => ({
            ...j,
            createDate: formatDate(j.createDate),
          })),
        ]}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditGroup
            {...{ setShowForm: setShowForm, updData, setAlert, setGroups }}
          />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Groups;
